<template>
  <div v-show="centerDialogVisible">
    <el-dialog
      :visible.sync="centerDialogVisible"
      width="500px"
      top="200px"
      center
      :destroy-on-close="true"
      @close="hidden()"
    >
      <img
        src="../../../static/img/icopj.png"
        height="40"
        width="40"
        style="float: left;margin-left: 15px;"
      />
      <span
        style="display: inline-block;height: 42px;line-height: 42px;float: left;margin-left: 10px"
        >{{ title }}</span
      >
      <span slot="footer" class="dialog-footer" style="display: none">
        <el-button @click="hidden()">取 消</el-button>
        <el-button type="primary" @click="hidden()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      centerDialogVisible: false
    };
  },
  methods: {
    show(time) {
      this.centerDialogVisible = true;
      if (time) {
        setTimeout(() => {
          this.hidden();
        }, time);
      } else {
        setTimeout(() => {
          this.hidden();
        }, 2000);
      }
    },
    hidden() {
      this.centerDialogVisible = false;
      this.remove();
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/notice/Notice.vue